import { useState } from "react";
import { Button, Form, Input, Row, Col, Spin } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import { numberOnly } from "../../../../utils/maskFunctions";
import { getDocPdf } from "../../../../services/apiDocumentos";
import { apiDocumentos } from "../../../../services/api";
import { errorMessage, infoMessage } from "../../../../messages/messages";
import type { IDocMessage } from "../../../../components/Interfaces";

export default function OnlyPdf() {
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [form] = Form.useForm();

  const pesquisaPdf = async () => {
    try {
      setLoading(true);
      setTipLoading("Pesquisando ...");

      const currentForm = form.getFieldsValue();

      const idImagem = numberOnly(currentForm.idImagem) || "";

      let lQuery = `/tmp_pesquisa_por_inicio_nome/${idImagem}`;

      const { data } = await apiDocumentos.get<IDocMessage>(lQuery);
      setLoading(false);

      console.log("data");
      console.log(data.message);

      if (data.idDocumento === -1) {
        infoMessage(data.message);
      } else {
        getDocPdf(data.idDocumento);
      }
    } catch (error: any) {
      errorMessage("Erro ao pesquisar/baixar arquivo: " + error.mensagem);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Spin spinning={loading} tip={tipLoading}>
        <Form layout='vertical' style={{ padding: 24 }} scrollToFirstError form={form} >

          <div className="main-content pl-sm-3 mt-4">
            <h1>Abre PDF</h1>
          </div>

          <div className="main-content pl-sm-3 mt-4">
            <h2>Seleção de imagem</h2>
          </div>

          <Row>
            <Col xs={12} md={8} xl={4}>
              <Form.Item label="ID Imagem"
                name="idImagem">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={12} xl={9}>
              <Button
                shape='round'
                onClick={() => pesquisaPdf()}
                icon={<ClearOutlined />}
              >
                Pesquisar/Baixar
              </Button>
            </Col>
          </Row>

        </Form>
      </Spin>
    </>
  );
}
